import React from "react";
import { PhotoProvider, PhotoView } from "react-photo-view";
import "./PortfolioGallery.css";

const PortfolioGalleryImages = ({
  showData,
  countColum,
  setDataToShow,
  dataToShow,
  data,
  gap,
}) => {
  return (
    <>
      <div
        style={{ columns: countColum, columnGap: 0 }}
        className="galleryContainer "
      >
        {showData.map((item) => (
          <div
            key={item.id}
            className="galleryItem  group relative cursor-pointer items-center justify-center overflow-hidden transition-shadow hover:shadow-xl hover:shadow-black/30"
          >
            {" "}
            <PhotoProvider>
              <PhotoView src={item.image}>
                <div className="">
                  <img
                    src={item.image}
                    alt=""
                    style={{ padding: gap / 2 }}
                    className={` h-full w-96 object-cover  transition-transform duration-500 group-hover:rotate-3 group-hover:scale-125`}
                  />

                  <div class="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black group-hover:from-black/70 group-hover:via-black/60 group-hover:to-black/70"></div>
                  <div class="absolute inset-0 flex  flex-col items-center justify-center px-9 text-center transition-all duration-500 group-hover:translate-y-0">
                    <h1 class="font-serif text-xl font-bold text-white opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                      {item.tag}
                    </h1>
                    <p class="mb-3 text-lg italic text-white opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                      {item.data}
                    </p>
                  </div>
                </div>
              </PhotoView>
            </PhotoProvider>
          </div>
        ))}
      </div>

      {dataToShow >= data.length ? (
        <div className="mt-10 text-center items-center mx-auto">
          <button
            className="bg-green-200  text-gray-700 font-bold py-2 px-8 rounded-xl"
            onClick={() => setDataToShow(dataToShow + 10)}
          >
            No More
          </button>
        </div>
      ) : (
        <>
          <div className="mt-10 text-center items-center mx-auto  ">
            <button
              className="bg-green-600   text-white font-bold py-2 px-8 rounded-xl"
              onClick={() => setDataToShow(dataToShow + 10)}
            >
              Load More
            </button>
          </div>
        </>
      )}
    </>
  );
};

export default PortfolioGalleryImages;
